import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'localTime'
})
export class LocalTimePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return this.utcToLocal(value);
  }

  utcToLocalx($filter) {
    return function (utcDateString, format) {
      if (!utcDateString) {
        return;
      }

      // append 'Z' to the date string to indicate UTC time if the timezone isn't already specified
      if (utcDateString.indexOf('Z') === -1 && utcDateString.indexOf('+') === -1) {
        utcDateString += 'Z';
      }

      return $filter('date')(utcDateString, format);
    };

  }

  utcToLocal(dateString) {
    let d = new Date(Date.parse(dateString));
    let timeOffsetInHours = (new Date().getTimezoneOffset() / 60) * (-1);

    d.setHours(d.getHours() + timeOffsetInHours);

    return d.getFullYear() + '-' + this.twoDigit(d.getMonth() + 1) + '-' + this.twoDigit(d.getDate()) + ' ' +
      this.twoDigit(d.getHours()) + ':' + this.twoDigit(d.getMinutes());
    // var dateFormat = require('dateformat');
    // var now = new Date();
    // dateFormat(now, "yyyy-MM-dd, HH:MM:ss");

    //return d.toJSON();
  }

  twoDigit(num) {
    if (num < 10) {
      return '0' + num;
    }
    return num;
  }
}
